import React, {
  useState,
  useEffect,
  useReducer,
  useRef,
} from "react";
import { useHistory } from "react-router";
import axios from "axios";

import PantallaContext from "./context/PantallaContext";
import { FuncionesProvider } from "./context/FuncionesContext";
import PantallaReducer, { initialState } from "./context/PantallaReducer";
import { useParams, useLocation } from "react-router";
//import SwitchMaestro from "./components/SwitchMaestro";
import { SwitchMaestroRender } from "./components/SwitchMaestroRender";
import HeaderConf from "./components/HeaderConf";
import Notificaciones from "./components/Notificaciones/Notificaciones";
import { ModalProvider } from "./context/ModalContext";
import {
  makeBody,
  resolveLocationStateFromReferrer,
  createSetPantalla,
  createCargarPantalla,
  createRefreshPantallaHandler,
  createPantallaLoadedHandler,
  createCargaPantallaEffect,
  createRefreshPantallaEffect,
  createPantallaLoadedEffect,
  createPantallaCssEffect,
  createConfirmarCerrarPantallaEffect,
} from "./PantallaFunciones";

import Debugger from "./components/Debugger";
import ChatAI from "./components/ChatAI";

import OrixiaSpinner from "./components/OrixiaSpinner";
import { useRefStore, useRefDataStore } from "../..";

const CancelToken = axios.CancelToken;

const Pantalla = () => {
  const [, dispatch] = useReducer(PantallaReducer, initialState);
  const history = useHistory();

  const [refState, setRefState] = useRefStore();
  const [refDataState, setData] = useRefDataStore();
  const opcionesPantalla = useRef(null);
  // console.log(conf);
  // console.log(conf_ref);

  let { pantalla } = useParams();
  const id_a = pantalla;
  // pantalla = pantalla.split("?")[0];
  const { search, state: rawLocationState = { filtros: {} } } = useLocation();

  const [loadingPantalla, setLoadingPantalla] = useState(true);
  const [pantallaCss, setPantallaCss] = useState("");

  const params = new URLSearchParams(search);
  let id = params.get("id");

  const qsBody = makeBody(search);
  const locationState = resolveLocationStateFromReferrer(rawLocationState);

  const cancelSource = useRef(null);
  const defaultTitle = useRef(document.title);

  const setPantalla = createSetPantalla({
    pantalla,
    id,
    setData,
    setRefState,
    setLoadingPantalla,
    setPantallaCss,
    opcionesPantalla,
  });

  const cargarPantalla = createCargarPantalla({
    pantalla,
    qsBody,
    cancelSource,
    history,
    setRefState,
    id,
    onSetPantalla: setPantalla,
  });

  const handleRefreshPantalla = createRefreshPantallaHandler({
    pantalla,
    qsBody,
    locationState,
    cancelSource,
    history,
    onSetPantalla: setPantalla,
    setLoadingPantalla,
    setRefState,
    refState,
  });

  const handlePantallaLoaded = createPantallaLoadedHandler({
    defaultTitle,
    opcionesPantalla,
  });

  useEffect(
    createCargaPantallaEffect({
      setLoadingPantalla,
      setPantallaCss,
      cancelSource,
      cancelToken: CancelToken,
      onCargarPantalla: cargarPantalla,
      locationState,
    }),
    [pantalla, id],
  );

  useEffect(
    createRefreshPantallaEffect({
      id_a,
      handleRefreshPantalla,
    }),
    [id_a],
  );

  useEffect(
    createPantallaLoadedEffect({
      handlePantallaLoaded,
    }),
    [opcionesPantalla, opcionesPantalla.opciones_de_pantalla],
  );

  useEffect(
    createPantallaCssEffect({
      pantalla,
      pantallaCss,
    }),
    [pantalla, pantallaCss],
  );

  useEffect(
    createConfirmarCerrarPantallaEffect({
      history,
      opcionesPantalla,
    }),
    [history, opcionesPantalla],
  );

  return (
    <PantallaContext.Provider
      value={{
        configuraciones: refState.configuraciones,
        opciones_de_pantalla: refState.opciones_de_pantalla,
        pantalla: refState.pantalla,
        pantalla_id: refState.pantalla_id,
        configuraciones_ref: refState.configuraciones_ref,
        configuraciones_ids: refState.configuraciones_ids,
        configuraciones_cab: refState.configuraciones_cab,
        configuraciones_padre: refState.configuraciones_padre,
        notificaciones: refState.notificaciones,
        data: refDataState,
        filtrosAplicados: refState.filtrosAplicados,
        PantallaDispatch: dispatch,
        loadingPantalla,
        sql: refState.sql,
        qsBody,
        refState,
      }}
    >
      <ModalProvider>
        <FuncionesProvider>
          <Debugger />
          <Notificaciones configuraciones={refState} />
          <HeaderConf
            opciones={loadingPantalla ? false : refState.opciones_de_pantalla}
            className={`configuracion_pantalla_titulo_principal `}
          />

          <div
            id={pantalla}
            style={{
              minHeight: "88vh", // Esto obliga a que mida como mÃ­nimo el alto de la pantalla
              display: "flex", // Opcional: ayuda a que el Card interno tambiÃ©n se comporte bien
              flexDirection: "column",
              overflowY: "hidden", // Solo muestra scroll vertical si es estrictamente necesario
              paddingBottom: "14px",
            }}
            className={refState.opciones_de_pantalla.className}
            data-component="Pantalla"
          >
            {loadingPantalla ? (
              <OrixiaSpinner text={"Cargando..."} />
            ) : (
              <SwitchMaestroRender
                refState={refState}
                id={id}
                qsBody={qsBody}
                opciones_de_pantalla={refState.opciones_de_pantalla}
              />
            )}
          </div>
          <ChatAI />
        </FuncionesProvider>
      </ModalProvider>
    </PantallaContext.Provider>
  );
};

export default Pantalla;
